/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Section_TitleInputs */

const es_user_profile_api_keys_section_title = /** @type {(inputs: User_Profile_Api_Keys_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave API`)
};

const en_user_profile_api_keys_section_title = /** @type {(inputs: User_Profile_Api_Keys_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

/**
* | output |
* | --- |
* | "API Key" |
*
* @param {User_Profile_Api_Keys_Section_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_section_title = /** @type {((inputs?: User_Profile_Api_Keys_Section_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Section_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_section_title(inputs)
	return en_user_profile_api_keys_section_title(inputs)
});
export { user_profile_api_keys_section_title as "user.profile.api_keys.section.title" }